module.exports = __webpack_public_path__ + "static/media/navigate_before_black_24dp.82b81390.svg";